import { render, staticRenderFns } from "./editAssetList.vue?vue&type=template&id=074b1207"
import script from "./editAssetList.vue?vue&type=script&lang=js"
export * from "./editAssetList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports